import { FuseAnimate, FusePageCarded } from "@fuse";
import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import SeletorData from "app/Core/Components/SeletorData/SeletorData";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import OnboardingToggle from "app/Core/Funcionalidade/Comunicador/Gerenciadores/Onboarding/OnboardingToggle";
import * as Helpers from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdAdd, MdAllInbox, MdAttachMoney, MdFormatListNumbered, MdMoveToInbox } from "react-icons/md";
import { TiMinus } from "react-icons/ti";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import TogglePesquisa from "../../Core/Components/PesquisaPainel/TogglePesquisa";
import EmpresaFinanceiroCaixaList from "./EmpresaFinanceiroCaixaList";
import EmpresaFinanceiroExtrato from "./EmpresaFinanceiroExtrato";
import EmpresaFinanceiroFaturamento from "./EmpresaFinanceiroFaturamento";
import EmpresaFinanceiroPagar from "./EmpresaFinanceiroPagar";
import EmpresaFinanceiroReceber from "./EmpresaFinanceiroReceber";
import EmpresaFinanceiroContas from "./EmpresaFinanceiroContas";
import EmpresaFinanceiroSidebar from "./EmpresaFinanceiroSidebar";
import * as Actions from "./Store/Actions/EmpresaFinanceiroActions";
import reducer from "./Store/Reducers/EmpresaFinanceiroReducer";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    },
    content: {
        backgroundColor: theme.palette.type === "dark" ? "#393939" : "#F0F0F0",
    },
});

const useFiltro = {
    caixa: [],
    caixaaberto: [],
    apagar: [1, 5],
    areceber: [1, 5],
    extrato: [4, 6],
    faturamento: [],
    contas: [1, 5, 7],
};

class EmpresaFinanceiroApp extends XAPPComponent {

    state = {
        acoes: null,
        condicoes: null,
        forceRender: 0,
        titulo: null,
        dataBase: Helpers.GetDataFirstDayMonth("usa"),
        idpessoaformulario: null,
    };

    componentDidUpdate() {
        if (this.props.EmpresaFinanceiro.error) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.error,
                variant: "error"
            });
            this.props.EmpresaFinanceiro.error = null;
        }
        if (this.props.EmpresaFinanceiro.warning) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.warning,
                variant: "warning"
            });
            this.props.EmpresaFinanceiro.warning = null;
        }
        if (this.props.EmpresaFinanceiro.info) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.info,
                variant: "success"
            });
            this.props.EmpresaFinanceiro.info = null;
        }
    }

    getAcoes = () => {
        return this.state.acoes;
    };

    setAcoes = (_AValue) => {
        this.setState(_.set({ ...this.state }, "acoes", _AValue));
    };

    setTitulo = (_AValue) => {
        this.setState(_.set({ ...this.state }, "titulo", _AValue));
    };

    getLabelTela = () => {
        const { tipo, user } = this.props;
        const { titulo } = this.state;
        var AResponse = "";
        switch (tipo) {
            case "caixa":
                AResponse = "Conferência de caixa";
                break;
            case "caixaaberto":
                AResponse = "Fechamento de caixa: " + user.displayName;
                break;
            case "apagar":
                AResponse = "Contas a pagar";
                break;
            case "areceber":
                AResponse = "Contas a receber";
                break;
            case "contas":
                AResponse = "Financeiro";
                break;
            case "faturamento":
                AResponse = "Faturamento";
                break;
            case "extrato":
                AResponse = "Extrato" + (!_.isNull(titulo) ? " - " + titulo : "");
                break;
            default:
                AResponse = "";
                break;
        }

        return AResponse;
    };

    getIconTela = (_AID) => {
        switch (_AID) {
            case "caixa":
                return <MdAllInbox className="text-24 text-white mx-8" />;
            case "caixaaberto":
                return <MdMoveToInbox className="text-24 text-white mx-8" />;
            case "apagar":
                return <TiMinus className="text-24 text-white mx-8" />;
            case "areceber":
                return <MdAdd className="text-24 text-white mx-8" />;
            case "contas":
            case "faturamento":
                return <MdAttachMoney className="text-24 text-white mx-8" />;
            case "extrato":
                return <MdFormatListNumbered className="text-24 text-white mx-8" />;
            default:
                return <div />;
        }
    };

    getContent = () => {
        const { tipo, user } = this.props;
        const { dataBase } = this.state;
        const xappRouteParams = this.props.match.params;
        switch (tipo) {
            case "caixa":
                return (
                    <EmpresaFinanceiroCaixaList
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.caixas)}
                        caixanaorecebido={this.props.EmpresaFinanceiro.caixanaorecebido}
                        tipo={tipo}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                        isGestor={true}
                    />
                );
            case "caixaaberto":
                return (
                    <EmpresaFinanceiroCaixaList
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.caixas)}
                        caixanaorecebido={this.props.EmpresaFinanceiro.caixanaorecebido}
                        tipo={tipo}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                        responsavel={user.settings.sistemas[xappRouteParams.empresa].idpessoaformulario}
                        isGestor={false}
                    />
                );
            case "apagar":
                return (
                    <EmpresaFinanceiroPagar
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.data)}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                    />
                );
            case "areceber":
                return (
                    <EmpresaFinanceiroReceber
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.data)}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                    />
                );
            case "contas":
                return (
                    <EmpresaFinanceiroContas
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.data)}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                    />
                );
            case "extrato":
                return (
                    <EmpresaFinanceiroExtrato
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.extrato)}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                        idpessoaformularioconta={this.state.idpessoaformulario}
                        setConta={this.setPessoaformulario}
                    />
                );
            case "faturamento":
                return (
                    <EmpresaFinanceiroFaturamento
                        xappRouteParams={xappRouteParams}
                        setAcoes={this.setAcoes}
                        getAcoes={this.getAcoes}
                        setTitulo={this.setTitulo}
                        data={Helpers.adapterFiltro(this.state.condicoes, this.props.EmpresaFinanceiro.faturamento)}
                        dataBase={dataBase}
                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                    />
                );
            default:
                return (
                    <div />
                );
        }
    };

    setCondicoes = (_AName, _AValue) => {
        var ACondicoes = {};
        if (!_.isUndefined(this.state.condicoes) && !_.isNull(this.state.condicoes)) {
            ACondicoes = { ...this.state.condicoes };
        }
        if (!_.isNull(_AValue)) {
            ACondicoes[_AName] = _AValue;
        }
        else {
            delete ACondicoes[_AName];
        }
        this.setState({ condicoes: ACondicoes });
    };

    toggleSidebar = () => {
        if (this.sidebarOpened()) {
            this.pageLayout.toggleRightSidebar();
            document.getElementById("sidebarWrapper").style.display = "none";
        }
        else {
            this.pageLayout.toggleRightSidebar();
            document.getElementById("sidebarWrapper").style.display = "";
        }
        this.setState(_.set({ ...this.state }, "forceRender", this.state.forceRender === 1 ? 0 : 1));
    };

    exibirPesquisaFiltro = (_ATipo, _AFuncionalidade) => {
        switch (_AFuncionalidade) {
            case "faturamento":
            case "caixaaberto":
            case "caixa": return _ATipo === 1;
            case "apagar":
            case "contas":
            case "areceber": return true;
            case "extrato": return !_.isNull(this.state.idpessoaformulario);
            default: return false;
        }
    };

    sidebarOpened = () => {
        return (
            _.isNull(md.mobile()) && _.isNull(md.tablet()) &&
            !_.isNull(document.getElementById("sidebarWrapper")) &&
            document.getElementById("sidebarWrapper").style.display === ""
        );
    };

    setPessoaformulario = (_AID) => {
        this.setState(_.set({ ...this.state }, "idpessoaformulario", _AID));
    };

    render() {
        const xappRouteParams = this.props.match.params;
        const { acoes, dataBase } = this.state;
        const { tipo, classes } = this.props;

        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            content: classes.content,
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            rightSidebar: "w-156 border-0 ",
                            header: "w-full min-h-48 h-48  xs:h-96 flex",
                            topBg: "min-h-48 h-48 xs:h-96",
                            sidebarHeader: "min-h-48 h-48 xs:h-96",
                        }}
                        header={
                            <div className="w-full flex items-center xs:flex-col xs:justify-center">
                                <div className="flex w-full">
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <Typography className="flex text-white items-center whitespace-no-wrap" variant="h6">
                                            {this.getIconTela(tipo)}
                                            {this.getLabelTela()}
                                        </Typography>
                                    </FuseAnimate>
                                </div>
                                {
                                    <SeletorData
                                        dataBase={dataBase}
                                        onChangeDataBase={(ev) => this.setState(_.set({ ...this.state }, "dataBase", ev))}
                                    />
                                }
                                <div className="flex w-full justify-end xs:w-fit xs:absolute xs:pin-t xs:pin-r">
                                    <OnboardingToggle
                                        empresa={xappRouteParams.empresa}
                                    />
                                    {this.exibirPesquisaFiltro(1, tipo) &&
                                        <TogglePesquisa
                                            id={tipo}
                                        />
                                    }
                                    {this.exibirPesquisaFiltro(2, tipo) &&
                                        <XAPPButton
                                            tooltip={{ "title": (this.sidebarOpened() ? "Ocultar filtro" : "Filtro"), "placement": "top" }}
                                            type="Icon"
                                            onClick={this.toggleSidebar}
                                            aria-label="open right sidebar"
                                            className="p-6 text-white"
                                            icon={this.sidebarOpened() ? "remove_filtro" : "filtro"}
                                        />
                                    }
                                </div>
                            </div>
                        }
                        content={
                            <React.Fragment>
                                {this.getContent()}
                            </React.Fragment>
                        }
                        rightSidebarHeader={
                            useFiltro[tipo].length > 0 && this.exibirPesquisaFiltro(2, tipo) &&
                            <div />
                        }
                        rightSidebarContent={
                            useFiltro[tipo].length > 0 && this.exibirPesquisaFiltro(2, tipo) &&
                            <div id="rightSidebarContent">
                                <EmpresaFinanceiroSidebar
                                    setCondicoes={this.setCondicoes}
                                    filtros={useFiltro[tipo]}
                                />
                            </div>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {acoes !== null &&
                        <div className={tipo !== "contas" && classes.addButton}>
                            {acoes}
                        </div>
                    }
                </CatchErro>
            </React.Fragment >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro, auth }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
        key: document.location.pathname,
        user: auth.user.data,
    };
}

export default withReducer("EmpresaFinanceiro", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroApp))));
